import React from 'react';
import { FormattedMessage } from 'react-intl';

function ReportMetricCard({ children, comparison, labelId, primary, testId }) {
  return (
    <article className="report-metric-card" data-testid={testId}>
      <div className="report-metric-card__label"><FormattedMessage id={labelId}/></div>
      <div className="report-metric-card__value">{primary}</div>
      {comparison && <div className="report-metric-card__comparison">{comparison}</div>}
      {children && <div className="report-metric-card__details">{children}</div>}
    </article>
  );
}

export { ReportMetricCard };
